

import __layout_0 from '/home/welcomepetobio/projects/vue-cdms/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/home/welcomepetobio/projects/vue-cdms/src/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithHorizontalNav': () => import('/home/welcomepetobio/projects/vue-cdms/src/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/home/welcomepetobio/projects/vue-cdms/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/home/welcomepetobio/projects/vue-cdms/src/layouts/components/Footer.vue'),
'components/LogoutTime': () => import('/home/welcomepetobio/projects/vue-cdms/src/layouts/components/LogoutTime.vue'),
'components/NavBarNotifications': () => import('/home/welcomepetobio/projects/vue-cdms/src/layouts/components/NavBarNotifications.vue'),
'components/NavSearchBar': () => import('/home/welcomepetobio/projects/vue-cdms/src/layouts/components/NavSearchBar.vue'),
'components/NavbarShortcuts': () => import('/home/welcomepetobio/projects/vue-cdms/src/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/home/welcomepetobio/projects/vue-cdms/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/ProjectTitle': () => import('/home/welcomepetobio/projects/vue-cdms/src/layouts/components/ProjectTitle.vue'),
'components/UserProfile': () => import('/home/welcomepetobio/projects/vue-cdms/src/layouts/components/UserProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
